import React, { useState, useEffect } from "react";
import Avatar from "./Avatar";
import InfoCircle from "../Info/InfoCircle";

const positions = {
  xs: "14",
  "xs-sm": "17",
  sm: "20",
  md: "25",
  lg: "30",
  xl: "35",
};

const borderStyles = {
  xs: `border-[1px]`,
  "xs-sm": `border-[2px]`,
  sm: `border-[3px]`,
  md: `border-[3px]`,
  lg: `border-[4px]`,
  xl: `border-[5px]`,
};

const GroupAvatar = ({
  //src,
  values,
  size = "md",
  noBorder = false,
}) => {
  return (
    <div className="relative flex w-full">
      {values.slice(0, 5).map((item, index) => (
        <div
          key={index}
          className={`absolute ${
            noBorder ? "" : borderStyles[size]
          } border-white rounded-full`}
          style={{
            left: `${index * positions[size]}px`,
            zIndex: values.length - index,
          }}
        >
          <Avatar
            alt={item.name}
            showInitials
            size={size}
            src={item.src}
            noBorder
          />
        </div>
      ))}

      {values.length > 5 && (
        <div
          className={`absolute`}
          style={{
            left: `${6 * positions[size]}px`,
          }}
        >
          <InfoCircle
            value={`+${values.length - 5}`}
            size={size}
            color="gray"
            colorDepth="100"
            noBorder
          />
        </div>
      )}
    </div>
  );
};

export default GroupAvatar;
